import React, {useEffect, Suspense} from 'react'
import {HashRouter as Router, Route, Switch, Redirect} from 'react-router-dom'
import {Provider} from 'mobx-react'
import RouteWithSubRoutes from '@components/routeWithSubRoutes'
import {refreshScale} from '@utils'
import store from './store'
import routes from './router'
// import './icon-svg'
import 'antd/dist/antd.css'
import './App.less'

function App() {
  useEffect(() => {
    refreshScale()
    window.addEventListener("pageshow", function (e) {
      if (e.persisted) { // 浏览器后退的时候重新计算
        refreshScale()
      }
    }, false);
    window.addEventListener("resize", refreshScale, false);
  })

  return (
    <Provider store={store}>
      <div className="App" id="app">
        <Suspense fallback={<div />}>
          <Router>
            <Switch>
              {
                routes.map(route => (
                  <RouteWithSubRoutes {...route} key={route.path} />
                ))
              }
              <Redirect from="/" exact to="/cockpit" />
              <Redirect from="/*" exact to="/cockpit" />
            </Switch>
          </Router>
        </Suspense>
      </div>
    </Provider>
  );
}

export default App;
